<script>
import Base from "@/components/RequestDetails/RequestLog.vue";

export default {
  name: "RequestLogNew",
  extends: Base,
  created() {
    this.$store.state.TaskDetailsDialog = false;
  },
  methods: {
    to_task_content(taskId) {
      const url = this.$router.resolve({
        name: "admin_tickets_details",
        params: { ticeket: taskId[0] },
      }).href;
      window.open(url, "_blank");
    },

    to_supportRequest_details(requestId) {
      const url = this.$router.resolve({
        name: "help_desk",
        params: { id: requestId[0] },
      }).href;
      window.open(url, "_blank");
    },
  },
};
</script>
